var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4035 0C15.7092 0.000259504 16.7684 1.05862 16.7687 2.36426V10.9639C16.7687 12.2698 15.7093 13.3288 14.4035 13.3291L2.36444 13.3291C1.05844 13.329 0.00017846 12.2699 0.00017846 10.9639L0.00017846 2.37695C-2.61015e-05 2.36686 -9.06901e-05 2.35679 0.00017846 2.34668C0.00994054 1.04903 1.0645 8.77361e-05 2.36444 0L14.4035 0ZM1.28924 10.9639C1.28924 11.5575 1.77084 12.039 2.36444 12.0391L14.4035 12.0391C14.9969 12.0388 15.4787 11.5574 15.4787 10.9639L15.4787 3.57031L8.74237 8.06152C8.52591 8.20583 8.24311 8.20557 8.02655 8.06152L1.28924 3.56934L1.28924 10.9639ZM2.36444 1.28906C1.88039 1.28913 1.46983 1.6097 1.33514 2.0498L8.38397 6.74902L15.4308 2.05078C15.2964 1.61046 14.8876 1.28927 14.4035 1.28906L2.36444 1.28906Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.db1dc1a3d356fe2ad589c435e63eed83.svg";
export { ForwardRef as ReactComponent };